export default __webpack_public_path__ + "static/media/wooBlack.cec101a3.svg";